import { useEffect, useRef } from 'react';

import { useMercureContext } from '@/common/contexts/MercureContext/MercureContext';

const useMercureMessageSubscriber = (topic, type, onMessage) => {
  const {
    messageSubscribe,
    messageUnsubscribe,
    userTopic,
  } = useMercureContext();
  const uidRef = useRef(crypto.randomUUID());
  const topicToSubscribe = topic ?? userTopic;

  useEffect(() => {
    messageSubscribe(uidRef.current, topicToSubscribe, type, onMessage);
  }, [onMessage, type, topicToSubscribe, messageSubscribe]);

  useEffect(
    () => () => {
      messageUnsubscribe(uidRef.current, topicToSubscribe, type);
    },
    [type, topicToSubscribe, messageUnsubscribe],
  );
};

export default useMercureMessageSubscriber;
